import { render, staticRenderFns } from "./MetricTable.vue?vue&type=template&id=6a98dc97"
import script from "./MetricTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports